/*
 * @Descripttion: 游戏轮播
 * @Author: huangfuchunmei
 * @Date: 2023-08-29 15:56:48
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-21 10:42:55
 */
import React ,{ useState, useEffect}from "react";
import styles from "./index.module.scss";
import LazyMedia from "@/components/LazyMedia";
import { IBanner } from "@/common/types";
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface ProductProps {
  gameContentsList: IBanner[]; // 首页游戏banner
  ctry?: string;
  words: Record<string, string>;
  device: string;
}
const GameSlider: React.FC<ProductProps> = ({
  gameContentsList,
  words,
  device,
}) => {

  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)

  // 获取swiper实例 处理鼠标enter/leave时暂停/播放
  const [swiper, setSwiper] = React.useState<any>(null)
  useEffect(() => {
    if (swiper) {
      const swiperDom = swiper.$el[0]
      swiperDom.addEventListener('mouseenter', () => swiper.autoplay.stop())
      swiperDom.addEventListener('mouseleave', () => swiper.autoplay.start())
    }
  }, [swiper])

  return (
    <>
      {gameContentsList && (
        <div className={styles["game-slider-wrap"]}>
          <NoSSR>
            <CustomSwiper
              loop={true}
              spaceBetween={24}
              centeredSlides={true}
              swiperSlideClass={styles["custom-swiper-slider"]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              setSwiper={setSwiper}>
              {gameContentsList?.map((item: IBanner) => (
                <div className={styles["slider-item"]} key={item.id} onClick={() => item?.url && window.open(item.url)}>
                  {
                    item[newDevice].extension === '.mp4'
                    ? <LazyMedia type="video" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                    : <LazyMedia type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                  }
                </div>
              ))}
            </CustomSwiper>
          </NoSSR>
        </div>
      )}
    </>
  );
};

export default GameSlider;
